import localStorage from "./localStorageService";

const key = "ADDIN_SETTINGS";

const defaultSettings = {
    expertMode: false
}

const get = () => {
    var settings = localStorage.get(key);
    if (settings) {
        return settings;
    }

    return defaultSettings;
}

const set = settings => {
    const settingsClone = Object.assign({}, settings);
    localStorage.set(key, settingsClone);
}

const clear = () => localStorage.remove(key);

export default {
    get,
    set,
    clear
}